var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_vm.enableFavoritesModal ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v(_vm._s(_vm.textMessage))])]), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl,
      expression: "imageUrl"
    }],
    staticClass: "modals-favorites-img",
    attrs: {
      "src": _vm.imageUrl,
      "alt": _vm.pdm.product_name
    },
    on: {
      "load": function load($event) {
        return _vm.hideSpinner(true);
      }
    }
  })]), _c('base-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSpinner,
      expression: "showSpinner"
    }]
  })], 1) : _c('h5', {
    staticClass: "text-center subheader"
  }, [_vm._v(_vm._s(_vm.textMessage))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }